import { render, staticRenderFns } from "./EsLogo.vue?vue&type=template&id=b4c7d210"
import script from "./EsLogo.vue?vue&type=script&lang=js"
export * from "./EsLogo.vue?vue&type=script&lang=js"
import style0 from "./EsLogo.vue?vue&type=style&index=0&id=b4c7d210&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports